module.exports = __webpack_public_path__ + "img/systemdata.13804c3b.jpg";